import { getCoreRowModel, PaginationState, useReactTable } from '@tanstack/react-table';
import React from 'react';

import { TablePagination } from './TablePagination';

interface StandalonePaginationProps {
    pagination: PaginationState;
    onPaginationChange: (next: PaginationState) => void;
    totalItems: number;
}

/** The data tables' pagination controls, usable without an actual table. */
export const StandalonePagination: React.FC<StandalonePaginationProps> = ({
    pagination,
    onPaginationChange,
    totalItems,
}) => {
    const table = useReactTable({
        data: [],
        columns: [],
        getCoreRowModel: getCoreRowModel(),
        manualPagination: true,
        rowCount: totalItems,
        state: { pagination },
        onPaginationChange: (updater) => {
            const next = typeof updater === 'function' ? updater(pagination) : updater;
            onPaginationChange(next);
        },
    });

    return <TablePagination table={table} />;
};
